import controller from './components.controller';
import template from './components.html';
import './components.css';

const HealthcarebookComponentsComponent = {
    bindings: {
    },
    controller,
    template,
};

export default HealthcarebookComponentsComponent;


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/components/components.component.js
// module id = 623
// module chunks = 0